export const SettingsStyles = (theme) => ({
    boxButtons: {
        display:'flex', 
        justifyContent: 'space-evenly',
        paddingTop: '2.5em'
    },
    button: {
        width: '20em',
        maxHeight: '45px',
        height: '40px',
        fontSize: '1.2rem',
        textTransform: 'none',
        borderRadius: '0.5em',
        backgroundColor: theme.palette.primary.black,
        color: theme.palette.primary.white,
        '&:hover': {
          backgroundColor: theme.palette.primary.black,
        },
    },
    buttonCancel: {
        width: '20em',
        maxHeight: '45px',
        height: '40px',
        fontSize: '1.2rem',
        textTransform: 'none',
        borderRadius: '0.5em',
        backgroundColor: theme.button.bgColorGray,
        color: theme.palette.primary.white,
        '&:hover': {
          backgroundColor: theme.button.bgColorGrayHover,
        },
      },
      dialog: {
        maxWidth: 'sm',
        title: {
          fontSize: '2rem',
          fontWeight: '700',
          color: theme.palette.primary.black,
        },
        content: {
          fontSize: '1.5rem',
          color: theme.palette.primary.black,
        },
        dialogBox: {
          '& .MuiDialog-paper': {
            padding: '48px',
          },
        },
        cancelButton: theme.button.bgColorGray,
        ctaButton: theme.palette.primary.black,
        showButton: 'none',
      },
})